import { render, staticRenderFns } from "./SystemUser.vue?vue&type=template&id=327c38c2&"
import script from "./SystemUser.vue?vue&type=script&lang=ts&"
export * from "./SystemUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports